import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AppsIcon from '@mui/icons-material/Apps';
import BarChartIcon from '@mui/icons-material/BarChart';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import PieChartIcon from '@mui/icons-material/PieChart';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  IComposableAnalyticsCharts,
  IComposableChartsWidget,
  IComposableDashboardContext,
} from 'wisestep-api';

import { Index } from '../../../composableAnalytics/Widgets/helper/freeTextWidgetKeys';
import { useComposableDashboardsContext } from '../../hooks/useComposableDashboardsContext';
import StyledButton from '../StyledButton';

const WidgetsList = ({ items }: { items: IComposableChartsWidget[] }) => {
  const { selectedDashboard, addWidget, removeWidget } =
    useComposableDashboardsContext() as Required<IComposableDashboardContext>;

  const chartType = (key: string) => key.split('_')[0];

  const getChartIcon = (chartType: string) => {
    switch (chartType) {
      case 'metric':
        return <LooksOneIcon />;
      case 'barchart':
        return <BarChartIcon />;
      case 'stackedbarchart':
        return <StackedBarChartIcon />;
      case 'table':
        return <TableChartIcon />;
      case 'piechart':
        return <PieChartIcon />;
      case 'heatmap':
        return <AppsIcon />;
      default:
        return <LooksOneIcon />;
    }
  };
  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {items.map(
        (chartObj) =>
          chartObj.type && (
            <ListItem
              key={chartObj.type}
              disableGutters
              sx={{ borderBottom: '1px solid black', marginTop: '2px' }}
              secondaryAction={
                <>
                  {(selectedDashboard.charts as IComposableAnalyticsCharts[]).find((chart) =>
                    chartObj.type == Index.FREE_TEXT_WIDGET ? false : chart.type === chartObj.type
                  ) ? (
                    <StyledButton
                      remove={true}
                      onClick={() => removeWidget(chartObj)}
                      variant="text"
                      size="small"
                      startIcon={<RemoveCircleIcon />}
                    >
                      Remove
                    </StyledButton>
                  ) : (
                    <StyledButton
                      remove={false}
                      variant="text"
                      size="small"
                      startIcon={<AddCircleOutlinedIcon />}
                      onClick={() => addWidget(chartObj)}
                    >
                      Add
                    </StyledButton>
                  )}
                </>
              }
            >
              <ListItemIcon>{getChartIcon(chartType(chartObj.type))}</ListItemIcon>
              <ListItemText primary={chartObj.name} />
            </ListItem>
          )
      )}
    </List>
  );
};

export default WidgetsList;
